<template>
  <div class="bodyTable">
    <v-form ref="form" v-model="formFieldsValid" lazy-validation>
      <v-data-table
        v-model="selected"
        color="blue lighten-4"
        item-key="codiceRiga"
        :headers="headers"
        :items="righeDocumento"
        :item-class="itemBackground"
        :options.sync="options"
        :server-items-length="totaleRighe"
        :loading="loading"
        class="elevation-1"
        @click:row="clickRow"
        @dblclick:row="dblclickRow"
        :disable-sort="true"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 15, 50, 100]
        }"
        dense
        calculate-widths
      >    
        <template v-slot:[`item.codice`]="{ item, index }">
          <component :is="'pProdotto'"  v-if="!item.rigaDescrittiva" :item="itemCodice(item)"
            :index="index" :appoggio="item.appoggio" :disabled="rowDisabled(item)" class="ml-2"
            :updateTrigger="updateTrigger" :suTable="true" :refreshSource="refreshSource" :refreshSourceCode="refreshSourceCode"
            :forzaAggiornamento="forzaAggiornamento" :abilitaRicercaInterna="abilitaRicercaInterna"
            @change="componentValueChange"/>
        </template>       
        <template v-slot:[`item.descrizione`]="{ item, index }">
          {{ (item.rigaIndentata ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : '') }}<component :is="'pTesto'" :item="itemDescrizione(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="rowDisabled(item)" :updateTrigger="updateTrigger" :suTable="true"/>
        </template>
        <template v-slot:[`item.fornitore`]="{ item, index }">
          <component :is="'pFornitoriProdotto'" :item="itemFornitore(item)" :soloPlaceholder="true" :appoggio="item.appoggio" :prodotto="item.prodotto" @change="componentValueChange" :index="index" :disabled="rowDisabled(item)" :updateTrigger="updateTrigger" :suTable="true"/>
        </template>
        <template v-slot:[`item.quantita`]="{ item, index }">
          <component :is="'pTesto'" :item="itemQuantita(item)" :ref="`quantita_${index}`" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="rowDisabled(item)" :updateTrigger="updateTrigger" :suTable="true"/>
        </template>
        <template v-slot:[`item.unitaMisura`]="{ item, index }">
          <component :is="'pMultiselect'" :item="itemUnitaMisura(item)" :index="index" :disableClear="true" :appoggio="item.appoggio" @change="componentValueChange" :disabled="rowDisabled(item)" :updateTrigger="updateTrigger" :suTable="true"/>
        </template>
        <template v-slot:[`item.appoggio.prodotto.acquistoFornitore`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getUltimoAcquisto(item, true) | euro" background-color="transparent"/>
        </template>
        <template v-slot:[`item.appoggio.prodotto.acquisto`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" class="text-caption" readonly :value="getUltimoAcquisto(item, false)" background-color="transparent"/>
        </template>        
        <template v-slot:[`item.appoggio.importoTotale`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getImportoTotale(item) | euro" background-color="transparent"/>
        </template>
        <template v-slot:[`item.motivo`]="{ item, index }">
          <component :is="'pTesto'" :item="itemMotivo(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="rowDisabled(item)" :updateTrigger="updateTrigger" :suTable="true"/>
        </template>        
        <template v-slot:[`item.giacenza`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getGiacenza(item)" background-color="transparent"/>
        </template>         
        <template v-slot:[`item.actions`]="{ item, index }">
          <v-icon small @click="deleteItem(item)" :disabled="rowDisabled(item)" title="Cancella la riga">mdi-delete</v-icon>
          <v-menu :offset-x="true" left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-3" :disabled="rowDisabled(item)" v-bind="attrs" v-on="on" title="Azioni aggiuntive">mdi-dots-vertical</v-icon>
            </template>
            <three-dots-menu :item="item" :index="index" :rowsNumber="righeDocumento.length" @click="menuClick"/>
          </v-menu>    
        </template>
        <template v-slot:[`foot`]>
          <v-btn class="text-right" :disabled="readOnly" @click="onNuovaRiga">Nuova riga</v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Confermi cancellazione riga ?</v-card-title>
          <v-card-text>{{dettaglioRiga}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
            <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <dialog-storico :show="dialogStorico" :prodotto="prodottoStorico" @aggiornaPrezzo="aggiornaPrezzo"/>
    </v-form>
  </div>
</template>

<script>
  import * as dot from 'dot-object'
  import _ from 'lodash'
  import prodotti from '@/services/prodottiService.js'
  import pProdotto from '../elementi/prodotto'
  // import pSwitch from '../elementi/switch'
  import pTesto from '../elementi/testo'
  // import pClifor from '../elementi/clifor'
  import pFornitoriProdotto from '../elementi/fornitoriProdotto'
  import pMultiselect from '../elementi/multiselect'
  // import pQuattroValori from './elementi/quattroValori'
  import ThreeDotsMenu from '../elementiBody/threeDotsMenu'
  import DialogStorico from '../elementiBody/dialogStorico'

  export default {
    components: {
      pProdotto,
      pTesto,
      // pClifor,
      pFornitoriProdotto,
      pMultiselect,
      ThreeDotsMenu,
      DialogStorico
      // pQuattroValori
    },
    props: {
      locDocumento: Object,
      trigger: { type: Number, default: 1 },
      readOnly: { type: Boolean, default: false }
    },
    data () {
      return {
        selected: [],
        loading: false,
        options: {},
        headers: [
          { text: 'Codice', value: 'codice', align: 'start', width: '10%'},
          { text: 'Descrizione', value: 'descrizione', width: '20%' },
          { text: 'Quantità', value: 'quantita', align: 'start', width: '5%' },
          { text: 'UM', value: 'unitaMisura', align: 'start', width: '4%' },
          { text: 'Fornitore', value: 'fornitore', align: 'start', width: '20%'},
          { text: 'Prezzo Acquisto', value: 'appoggio.prodotto.acquistoFornitore', align: 'start'},
          { text: 'Importo Totale', value: 'appoggio.importoTotale' , align: 'start'},
          { text: 'Motivare scelta', value: 'motivo', align: 'start', width: '15%'},
          { text: 'Giac.', value: 'giacenza' , align: 'start'},
          { text: 'Actions', value: 'actions', sortable: false }
        ],
        expanded: [],
        singleExpand: false,
        dialog: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
/*         defaultItem: null,
        modelloDocumento: null, */
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        // impostazioniEtichette: null,
        usaQtaAnagrafica: false, // TODO: da configurazioni
        salta: 0,
        filtroElementi: null,
        tipoStampa: '',
        report: '',
        erroreDocumento: '',
        updateTrigger: 1,
        refreshSource: 1,
        refreshSourceCode: '',
        forzaAggiornamento: false,
        locRigaDocumento: null,
        rigaModello: {
          rigaDescrittiva: false,
          codice: '',
          descrizione: '',
          quantita: '',
          unitaMisura: '',
          fornitore: null,
          listino: null,
          aliquota: null,
          prezzi: null,
          sconti: null,
          importi: null
        },
        aggiornaSconti: true, // da impostazioni scelgo se aggiornare gli sconti o il prezzo di listino nel caso di modifica dell'importo
        dialogStorico: false,
        prodottoStorico: null,
        mostraParcheggio: false,
        formFieldsValid: true,
        abilitaRicercaInterna: false // TODO: Prendere da impostazioni/backoffice/prodotti/abilitaRicercaInterna
      }
    },
    computed: {
      righeDocumento() {
        return _.get(this, 'locDocumento.righe', [])
      },
      totaleRighe() {
        return this.righeDocumento.length
      },
      nuovaRigaAbilitata() {
        return this.trigger && this.locDocumento.anagrafica
      },
      dettaglioRiga() {
        let riga = this.editedIndex
        if (riga === -1) return
        let ed = this.righeDocumento[riga]
        if (!ed) return ''
        return ed.descrizione.trim()
      }     
    },
    watch: {
      options: {
        async handler () {
          // await this.getDataFromApi()
        },
        deep: true
      },
      dialog (val) {
        val || this.dialogClose()
      },     
      dialogDelete (val) {
        val || this.closeDelete()
      }
    },
    async mounted () {
      this.$root.$on('aggiungiProdotti', this.onAggiungiProdotti)
    },
    methods: {
      rowDisabled(item) {
        return this.readOnly || (item && !!item.ordineMultiplo)
      },
      datiCompleti() {
        const valid = this.$refs.form.validate()
        return valid
      },  
      itemFornitore(item) {
        return {
          "model": "prodotto.fornitore",
          "valueField": "prodotto.fornitore",
          "label": "Fornitore",
          "type": "Clifor",
          "required": false,
          addForbidden: true,
          value: _.get(item, 'prodotto.fornitore', '')
        }
      },
      itemCodice(item) {
        return {
          "model": "prodotto.codice",
          "valueField": "prodotto.codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "prodotto.descrizione",
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          "cercaEsterno": true,
          value: _.get(item, 'prodotto.codice', '')          
        }
      },
      itemDescrizione(item) {
        return {
          "model": "descrizione",
          "valueField": "descrizione",
          "label": "Descrizione",
          "type": "TextArea",
          "required": true,
          value: _.get(item, 'descrizione', '') 
        }
      },
      itemQuantita(item) {
        return {
          "model": "quantita",
          "valueField": "quantita",
          "label": "Quantità",
          "type": "Testo",
          "required": !_.get(item, 'appoggio.rigaDescrittiva', false),
          "numerico": true,
          "decimals": 2,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'quantita', '') 
        }
      },
      itemMotivo(item) {
        const prezzo = _.get(item, 'prodotto.fornitore.prezzo', 0)
        const minimo = _.get(item, 'prodotto.fornitore.minimo', 0)
        const richiesto = prezzo !== 0 && minimo !== 0 && prezzo !== minimo

        return {
          "model": "motivo",
          "valueField": "motivo",
          "label": "",
          "type": "Testo",
          "required": richiesto,
          value: _.get(item, 'motivo', '') 
        }
      },
      itemUnitaMisura(item) {
        return {
          "model": "unitaMisura",
          "valueField": "unitaMisura",
          "type": "Multiselect",
          "label": "UM",
          "source": "prodotti_unita_misura.um",
          "required": true,
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'unitaMisura', '') 
        }
      },
      itemBackground(item) {
        return item.ordineMultiplo ? 'is-ordine-multiplo' : ''
      },      
      getGiacenza(item) {
        return _.get(item, 'appoggio.prodotto.item.magazzino.giacenza', 0)
      },      
      getImportoTotale(item) {
        const pz = this.getUltimoAcquisto(item, true)
        const qta = item.quantita || 0
        // return item.costoTotale || (qta ? +(pz * qta).toFixed(2) : '0')
        return qta ? +(pz * qta).toFixed(2) : '0'
      },      
      getPrezzoUnita(item, unita) {
        // ritorna il prezzo in base all'unità di misura selezionata
        // TODO: Gestire nel prodotto un array di valori con i corrispondenti fattori di conversione
        // Per adesso considero solo 2 prezzi (confezione/chilo e pezzo)
        const prezzoPezzo = _ .get(item, 'appoggio.prodotto.item.magazzino.prezzoAcquistoPezzo', 0)
        const prezzo = _.get(item, 'appoggio.prodotto.acquisto', 0)
        if (['pz', 'n'].includes(unita)) {
          return prezzoPezzo
        } else {
          return prezzo
        }
      },      
      getUltimoAcquisto(item, fornitore) {
        if (fornitore) {
          // return _.get(item, 'prodotto.fornitore.prezzo')

          // Ritorna il prezzo di acquisto dal fornitore scelto per l'ordine
          //const fo = _.get(this.locDocumento, 'anagrafica.fornitore', null)
          const fo = _.get(item, 'prodotto.fornitore', null)
          const ff = _.get(item, 'prodotto.fornitore.items', []) || _.get(item, 'appoggio.prodotto.item.fornitori', [])
          const f = fo && ff.find(x => x.codice === fo.codice)

          if (f) {
            return _.get(item, 'prodotto.fornitore.prezzo') || this.getPrezzoUnita(item, 'pz') || f.prezzo || this.getPrezzoUnita(item)
          } else {
            return this.getPrezzoUnita(item, item.unitaMisura && item.unitaMisura.codice) // prezzoPezzo || _.get(item, 'appoggio.prodotto.acquisto', 0) || _.get(item, 'appoggio.prodotto.item.ultimoAcquisto.prezzo', '0')
          }          
        } else {
          // Ritorna i dati dell'ultimo acquisto effettuato, anche se da fornitore diverso
          const ua = _.get(item, 'appoggio.prodotto.item.ultimoAcquisto', null)
          return _.get(ua,'fornitoreDescrizione', false) ? `${ua.fornitoreDescrizione} @ ${this.$options.filters.date(ua.data)} ( ${ua.quantita} : ${this.$options.filters.euro(this.getPrezzoUnita(item, item.unitaMisura && item.unitaMisura.codice) || ua.prezzo)} )` : '0'
        }
      },      
      async onNuovaRiga() {
        const nr = JSON.parse(JSON.stringify(this.rigaModello))
        nr.valore = nr.valore || {}
        // nr.valore.listino = this.locDocumento.appoggio.clifor.amministrativi.listino
        // nr.valore = { ...nr.valore, ...this.locDocumento.appoggio.clifor.amministrativi.sconti }
        this.$emit('nuovaRiga', nr)
      },      
      clickRow(item, options) {},
      dblclickRow(event, options) {},
      deleteItem (item) {
        this.editedIndex = this.righeDocumento.indexOf(item)
        this.dialogDelete = true
      },
      async deleteItemConfirm () {
        this.righeDocumento.splice(this.editedIndex, 1)
        this.forzaAggiornamento = true
        this.closeDelete()
        this.editedIndex = -1
        this.$emit('updateTotali')
        await this.$nextTick()
        this.forzaAggiornamento = false        
      },

      close () {
        this.dialog = false
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedIndex = -1
        })
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      },
      aggiornaPrezzo({ listino, valore, codice }) {
        this.forzaAggiornamento = false
        this.refreshSourceCode = codice
        this.refreshSource++
      },
      async menuClick({ command, index }) {
        switch(command) {
          case 'utility_storico':
            this.dialogStorico = true
            this.prodottoStorico = this.locDocumento.righe[index]
            await this.$nextTick()
            this.dialogStorico = false
            break
          case 'move_top':
            this.$emit('move', index, 0)
            break
          case 'move_bottom':
            this.$emit('move', index, -1)
            break
          case 'move_up':
            this.$emit('move', index, index - 1)
            break
          case 'move_down':
            this.$emit('move', index, index + 1)
            break
          default:
            break
        }
      },      
      async componentValueChange(data) {
        const { model, subModel, value, decimals, index } = data
        this.locRigaDocumento = this.righeDocumento[index]
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {s
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        _.merge(this.locRigaDocumento, tgt)
        await this.aggiornaCorrelati(data)
      },
      async aggiornaCorrelati(data) {
        this.locRigaDocumento.appoggio = this.locRigaDocumento.appoggio || {}
        let tipoModifica = ''
        switch (data.model) {
          case 'prodotto.codice':
            if (!data.value) {
              delete this.locRigaDocumento.appoggio.prodotto
              delete this.locRigaDocumento.prodotto
              _.set(this.locRigaDocumento, 'valore.prezzoUnitario', 0)   
              this.locRigaDocumento.descrizione = ''
            } else {
              this.locRigaDocumento.appoggio.prodotto = data.item
              this.locRigaDocumento.descrizione = `${data.item.descrizione} ${_.get(data.item, 'variante2.descrizione', '')} ${_.get(data.item, 'variante1.descrizione', '')}`.trim()
              if (this.locRigaDocumento.appoggio.importiModificati) { // La prima volta, devo rileggere il prodotto ma non impostare il listino. Se cambio prodotto, si
                this.locRigaDocumento.appoggio.importiModificati = false
                this.updateTrigger++
                return
              }
              this.locRigaDocumento.tipoBene = data.item.tipoBene || data.item.item.tipoBene
              this.locRigaDocumento.repartoFiscale = data.item.datiFiscali.reparto.stampante
              
              let um = _.get(this, 'locRigaDocumento.unitaMisura', '') || _.get(data.item, 'magazzino.unitaMisura', '') || _.get(data.item, 'item.magazzino.unitaMisura', '') || _.get(data.item, 'item.magazzino.um', '')
              this.locRigaDocumento.unitaMisura = um
              
              this.locRigaDocumento.aliquotaIva = data.item.datiFiscali.aliquoteIva[0]
              await this.$nextTick()
              const ref = this.$refs[`quantita_${data.index}`]
              const input = ref.$el.querySelector('input:not([type=hidden]),textarea:not([type=hidden])')
              if (input) {
                setTimeout(() => {
                  input.focus()
                }, 0)
              }
            }
            break;
          case 'rigaDescrittiva':
            delete this.locRigaDocumento.appoggio.prodotto
            delete this.locRigaDocumento.prodotto
            _.set(this.locRigaDocumento, 'valore.prezzoUnitario', 0)
            _.set(this.locRigaDocumento, 'appoggio.rigaDescrittiva', data.value)       
            this.locRigaDocumento.descrizione = ''
            break;
          case 'valore.listino':
            _.set(this.locRigaDocumento,'appoggio.listino.ivato', _.get(data,'value.ivato', true))
            _.set(this.locRigaDocumento,'appoggio.listino.nonIvato', !_.get(data,'value.ivato', true))
            tipoModifica = data.model
            break;
          case 'valore.sconto1':
          case 'valore.sconto2':
          case 'valore.sconto3':
          case 'valore.sconto4':
            this.locRigaDocumento.sconti = this.rigaSconti(this.locRigaDocumento.valore)
            tipoModifica = data.model
            break;
          case 'valore.prezzoUnitario':          
          case 'valore.prezzoTotale':
          case 'valore.prezzoNettoUnitario':
          case 'valore.prezzoNettoTotale':
          case 'valore.importoUnitario':
          case 'valore.importoTotale':
          case 'valore.importoNettoUnitario':
          case 'valore.importoNettoTotale':
            tipoModifica = data.model
            this.locRigaDocumento.valore.importiModificati = true // viene messo su appoggio alla successiva riapertura della riga
            break;        
          case 'appoggio.aliquotaIva':
            this.locRigaDocumento.aliquotaIva = this.locRigaDocumento.appoggio.aliquotaIva
            this.locRigaDocumento.aliquotaIva.valore = this.locRigaDocumento.aliquotaIva.aliquota
            tipoModifica = data.model
            break;
          case 'quantita':       
            tipoModifica = data.model   
            break;
          default:
            break
        }
        this.aggiornaValori(tipoModifica)
        this.updateTrigger++
        this.$emit('updateTotali')
      },
      aggiornaValori(tipoModifica) {}      
    }
  }

</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
    td.articoliSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }

  .bodyTable .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0;
  }

  .is-ordine-multiplo {
    background-color: #edd1c8;
  }
</style>
